
import DefaultCell from "application/components/DefaultCell";


const operationURLS = {
  list: "/blasterReport/list",
  pdfDownload: "/blasterReport/generateAndDownloadPdf",
  csvDownload: "/blasterReport/downloadCSV",
};

const getColumns = () => {
  return [
    {
      Header: "Start Stamp",
      accessor: "startStamp",
      displayInList: true,
      allowFilter: true,
      dataType: "date",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Caller Id Number",
      accessor: "callerIdNumber",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Destination Number",
      accessor: "destinationNumber",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Duration",
      accessor: "duration",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Bill Sec",
      accessor: "billSec",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Hangup Cause",
      accessor: "hangupCause",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    ,
    {
      Header: "Digits Dialed",
      accessor: "digitsDialed",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
  ];
};

export { getColumns, operationURLS };
